/*
 * Copyright (c) 2024. Tooling Team
 */

export default class HeaderService {
  //TODO: expand this
  getAllHeaders = () => {
    const headers = {
      ...this.getTenantHeader(),
      ...this.getAuthorizationHeader(),
      ...this.getXUpstreamEnvHeader(),
    };
    return headers;
  };

  getTenantHeader = () => {
    const header = {
      Tenantid: "2",
    };
    return header;
  };

  getAuthorizationHeader = () => {
    const accessToken = this.getAccessToken();
    const header = {
      Authorization: "Bearer " + accessToken,
    };
    return header;
  };

  getAccessToken = () => {
    const oidcStorage = JSON.parse(
      sessionStorage.getItem(
        `oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`
      )
    );
    return oidcStorage && oidcStorage.access_token;
  };

  getXUpstreamEnvHeader = () => {
    const header = {
      "X-Upstream-Env": "dev",
    };
    return header;
  };

  // getAccessOriginHeader = () => {
  //   const header = {
  //     "Access-Control-Allow-Origin":
  //       "https://dev-phi.cmt.data-enablement.optum.com/",
  //   };
  //   return header;
  // };
}
